import { Component } from "react"
import PropTypes from "prop-types"
import { TextField, InputAdornment, Button, FormControl } from "@mui/material"
import { LockOutlined } from "@mui/icons-material"
import { size, pick } from "lodash"
import classNames from "classnames"
import passwordTester from "owasp-password-strength-test"
import Error from "../../components/login/form-error"
import { getPasswordStrength, getStrengthText } from "helpers/password"
import withNavigate from "hocs/withNavigate"

import "./style.scss"

class SetPassword extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    subText: PropTypes.string,
    error: PropTypes.object,
    buttonText: PropTypes.string.isRequired,
    token: PropTypes.string,
    redirect: PropTypes.string,
    setPassword: PropTypes.func.isRequired,
    deleteError: PropTypes.func.isRequired,
    userActivation: PropTypes.bool,
    mfaEnabled: PropTypes.bool,
    passwordExpired: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      focus: false,
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const { token, redirect, setPassword } = this.props
    const data = { token, redirect, ...pick(this.state, ["password", "confirm", "mfaToken"]) }
    setPassword(data)
  }

  handleChange = (e) => {
    const name = e.target.name
    let stateChanges = {
      [e.target.name]: e.target.value,
    }

    if (name === "password") {
      passwordTester.config({
        allowPassphrases: true,
        maxLength: 128,
        minLength: 10,
        minPhraseLength: 20,
        minOptionalTestsToPass: 3,
      })
      const result = passwordTester.test(e.target.value)

      stateChanges = {
        ...stateChanges,
        strength: getPasswordStrength(e.target.value, result),
        passwordLength: size(e.target.value),
        strongPassword: result.strong,
      }
    }

    this.setState(stateChanges)
  }

  handleGoToLogin = () => {
    const { navigate } = this.props
    navigate("/", { replace: true })
  }

  toggleFocus = (newFocus) => () => {
    this.setState({ focus: newFocus })
  }

  render() {
    const { title, text, subText, buttonText, error, deleteError, userActivation, mfaEnabled, passwordExpired } = this.props
    const { strength, passwordLength, strongPassword, focus, mfaToken } = this.state
    const strengthText = getStrengthText(strength)

    return <div className="set-password">
      <div className="title">{title}</div>
      <div className="text">{text}</div>
      {subText && <div className="text">{subText}</div>}
      {error && <Error clearError={deleteError} errorMessage={error.message} nonRemovable={error.nonRemovable} />}

      <form className="form" onSubmit={this.handleSubmit}>
        <FormControl variant="standard">
          <TextField
            className="password-box"
            name="password"
            icon="lock"
            type="password"
            onChange={this.handleChange}
            onFocus={this.toggleFocus(true)}
            onBlur={this.toggleFocus(false)}
            label="Password"
            variant="outlined"
            slotProps={{
              input: {
                startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start"><LockOutlined className="textinput-icon" /></InputAdornment>,
              },
            }}
          />
        </FormControl>
        <div className="strength-wrapper">
          <div
            className={classNames("strength-meter mt-2", {
              visible: passwordLength && passwordLength > 0,
              invisible: !passwordLength || passwordLength <= 0,
            })}
          >
            <div className="strength-meter-fill" data-strength={strength} />
          </div>
          <span className={`strength-text ${passwordLength > 0 ? "visible" : "invisible"}`} data-strength={strength}>{strengthText}</span>
        </div>
        <div className={classNames("tooltip", {
          invisible: !focus,
          activation: userActivation,
        })}
        >
          <div className="arrow" />
          <div className="password-strength">
            <div>Password / Passphrase</div>
            <div className="section">Provide a strong password between 10-19 characters, does not contain 3 or more consecutive repeated characters, and has at least 3 of the following:</div>
            <ul className="section password-other-criterias">
              <li>Lower case</li>
              <li>Upper case</li>
              <li>At least one number</li>
              <li>At least one symbol</li>
            </ul>

            <div className="section"><b>OR</b></div>

            <div className="section">Provide a passphrase that is any phrase with 20-128 characters and does not contain 3 or more consecutive repeated characters</div>
          </div>
        </div>
        <FormControl variant="standard">
          <TextField
            className="password-box-confirm"
            name="confirm"
            type="password"
            onChange={this.handleChange}
            label="Confirm Password"
            variant="outlined"
            slotProps={{
              input: {
                startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start"><LockOutlined className="textinput-icon" /></InputAdornment>,
              },
            }}
          />
        </FormControl>
        {mfaEnabled
          && <FormControl variant="standard">
            <TextField
              className="mfa-code"
              name="mfaToken"
              onChange={this.handleChange}
              label="Authentication Code"
              variant="outlined"
            />
          </FormControl>}
        <Button className="confirm-button" variant="contained" color="primary" disabled={!strongPassword || (mfaEnabled && !mfaToken)} onClick={this.handleSubmit}>{buttonText}</Button>
      </form>
      {!passwordExpired && <div className="text login-account">
        Already have an account?
        <div className="navigate" onClick={this.handleGoToLogin}>Log in</div>
      </div>}
    </div>
  }
}

export default withNavigate(SetPassword)
